import type { ReactNode } from 'react';
import React from 'react';
import { createContext } from '@shared/utils/createContext';
import type { UploadedPreviewImages } from '@shared/components/PreviewWithPhoto/PreviewWithPhoto.types';

type CardPreviewWithPhotoContextValue = Readonly<{
  photos: UploadedPreviewImages;
  /** True when printPreviewWithPhotoCards is enabled — suppresses event-album auto-populate
   *  so thumbnails stay blank until the user explicitly picks preview photos. */
  isEnabled: boolean;
}>;

// Non-strict context: card gallery items read this even when no provider is mounted.
const [Provider, useCardPreviewWithPhotoContext] = createContext<CardPreviewWithPhotoContextValue>({
  name: 'CardPreviewWithPhotoContext',
  strict: false,
  initialValue: { photos: [], isEnabled: false },
});

export const CardPreviewWithPhotoProvider = (props: { photos: UploadedPreviewImages; isEnabled: boolean; children: ReactNode }) => (
  <Provider value={{ photos: props.photos, isEnabled: props.isEnabled }}>{props.children}</Provider>
);

export { useCardPreviewWithPhotoContext };
